var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "d-flex flex-wrap align-center mb-3"
        },
        [
          _c(
            "div",
            {
              staticClass: "mr-auto",
              attrs: {
                role: "group",
                "aria-label": "Filter by category"
              }
            },
            _vm._l(_vm.categories, function(c) {
              return _c(
                "v-btn",
                {
                  key: c,
                  staticClass: "mr-2 mb-2 text-capitalize kvm-pick__pill",
                  class: {
                    "kvm-pick__pill--active": c === _vm.activeCategory
                  },
                  attrs: {
                    small: "",
                    rounded: "",
                    depressed: "",
                    color: c === _vm.activeCategory ? "primary" : "",
                    text: c !== _vm.activeCategory,
                    "aria-pressed": c === _vm.activeCategory ? "true" : "false"
                  },
                  on: {
                    click: function click($event) {
                      _vm.activeCategory = c
                    }
                  }
                },
                [_vm._v(_vm._s(c))]
              )
            }),
            1
          ),
          _c("v-text-field", {
            staticStyle: {
              "max-width": "240px"
            },
            attrs: {
              "prepend-inner-icon": "mdi-magnify",
              placeholder: "Search",
              "aria-label": "Search operating systems and apps",
              outlined: "",
              dense: "",
              "hide-details": "",
              clearable: ""
            },
            model: {
              value: _vm.search,
              callback: function callback($$v) {
                _vm.search = $$v
              },
              expression: "search"
            }
          })
        ],
        1
      ),
      _c(
        "v-row",
        {
          attrs: {
            dense: "",
            role: "group",
            "aria-label": "Operating system and application catalog"
          }
        },
        [
          _vm._l(_vm.filteredItems, function(item) {
            return _c(
              "v-col",
              {
                key: item.kind + ":" + item.slug,
                attrs: {
                  cols: "12",
                  sm: "6",
                  md: "4",
                  lg: "3"
                }
              },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "vds-pick-card",
                    style: _vm.isSelected(item) ? _vm.selectedStyle : null,
                    attrs: {
                      outlined: "",
                      role: "button",
                      tabindex: "0",
                      "aria-haspopup": "dialog",
                      "aria-pressed": _vm.isSelected(item) ? "true" : "false",
                      "aria-label": _vm.cardAriaLabel(item)
                    },
                    on: {
                      click: function click($event) {
                        return _vm.openDetail(item)
                      },
                      keydown: [
                        function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.openDetail(item)
                        },
                        function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "space", 32, $event.key, [
                              " ",
                              "Spacebar"
                            ])
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.openDetail(item)
                        }
                      ]
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex align-center pa-3"
                      },
                      [
                        _c("kvm-logo", {
                          staticClass: "mr-3",
                          attrs: {
                            item: item,
                            size: 28,
                            "default-icon": _vm.defaultIcon(item)
                          }
                        }),
                        _c(
                          "span",
                          {
                            staticClass: "body-2 text-truncate flex-grow-1",
                            attrs: {
                              title: item.name
                            }
                          },
                          [_vm._v(_vm._s(item.name))]
                        ),
                        _vm.isSelected(item)
                          ? _c(
                              "v-icon",
                              {
                                staticClass: "ml-1",
                                attrs: {
                                  small: "",
                                  color: "primary",
                                  "aria-hidden": "true"
                                }
                              },
                              [_vm._v("mdi-check-circle")]
                            )
                          : item.popular
                          ? _c(
                              "v-icon",
                              {
                                staticClass: "ml-1",
                                attrs: {
                                  small: "",
                                  color: "amber darken-2",
                                  "aria-hidden": "true"
                                }
                              },
                              [_vm._v("mdi-star")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          }),
          !_vm.filteredItems.length
            ? _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "text-center py-6 mb-0 kvm-pick__empty"
                    },
                    [_vm._v("No matches.")]
                  )
                ]
              )
            : _vm._e()
        ],
        2
      ),
      _vm.value && _vm.selectedItem
        ? _c(
            "v-alert",
            {
              staticClass: "mt-2 mb-0 kvm-pick__summary",
              attrs: {
                dense: "",
                text: "",
                color: "primary",
                "aria-live": "polite"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "d-flex align-center"
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "mr-auto"
                    },
                    [
                      _vm._v("Selected: "),
                      _c("strong", [_vm._v(_vm._s(_vm.selectedItem.name))]),
                      _vm._v(_vm._s(_vm.selectedOptionsText))
                    ]
                  ),
                  _c(
                    "gg-btn",
                    {
                      staticClass: "kvm-pick__btn",
                      attrs: {
                        "x-small": "",
                        text: "",
                        "aria-label":
                          "Change options for " + _vm.selectedItem.name
                      },
                      on: {
                        click: function click($event) {
                          return _vm.openDetail(_vm.selectedItem)
                        }
                      }
                    },
                    [_vm._v("Change")]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "560",
            scrollable: ""
          },
          model: {
            value: _vm.dialog,
            callback: function callback($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _vm.active
            ? _c(
                "gg-card",
                {
                  attrs: {
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "kvm-pick-dialog-title"
                  }
                },
                [
                  _c(
                    "gg-card-text",
                    {
                      staticClass: "pa-4"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex align-start mb-3"
                        },
                        [
                          _c("kvm-logo", {
                            staticClass: "mr-3",
                            attrs: {
                              item: _vm.active,
                              size: 40,
                              "default-icon": _vm.defaultIcon(_vm.active)
                            }
                          }),
                          _c(
                            "div",
                            {
                              staticClass: "flex-grow-1"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "body-1 font-weight-medium",
                                  attrs: {
                                    id: "kvm-pick-dialog-title"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.active.name))]
                              ),
                              _vm.active.subtitle
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-caption kvm-pick__subtitle"
                                    },
                                    [_vm._v(_vm._s(_vm.active.subtitle))]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm.active.popular
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ml-2 mt-1",
                                  attrs: {
                                    "x-small": "",
                                    color: "grey lighten-3"
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        "x-small": "",
                                        left: "",
                                        color: "amber darken-2",
                                        "aria-hidden": "true"
                                      }
                                    },
                                    [_vm._v("mdi-star")]
                                  ),
                                  _vm._v("Popular ")
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-btn",
                            {
                              staticClass: "ml-1 kvm-pick__btn",
                              attrs: {
                                icon: "",
                                small: "",
                                "aria-label": "Close"
                              },
                              on: {
                                click: function click($event) {
                                  _vm.dialog = false
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    small: "",
                                    "aria-hidden": "true"
                                  }
                                },
                                [_vm._v("mdi-close")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.renderedDescription
                        ? _c("div", {
                            staticClass: "vds-pick-desc body-2 mb-3",
                            domProps: {
                              innerHTML: _vm._s(_vm.renderedDescription)
                            }
                          })
                        : _vm._e(),
                      (_vm.active.links || []).length
                        ? _c(
                            "div",
                            {
                              staticClass: "mb-4"
                            },
                            _vm._l(_vm.active.links, function(l, i) {
                              return _c(
                                "a",
                                {
                                  key: i,
                                  staticClass:
                                    "mr-4 text-caption kvm-pick__link",
                                  attrs: {
                                    href: l.url,
                                    target: "_blank",
                                    rel: "noopener noreferrer"
                                  }
                                },
                                [
                                  _vm._v(_vm._s(l.label) + " "),
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        "x-small": "",
                                        "aria-hidden": "true"
                                      }
                                    },
                                    [_vm._v("mdi-open-in-new")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "kvm-sr-only"
                                    },
                                    [_vm._v(" (opens in a new tab)")]
                                  )
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm._l(_vm.active.options || [], function(opt) {
                        return _c(
                          "div",
                          {
                            key: opt.key,
                            staticClass: "mb-3"
                          },
                          [
                            _vm.optType(opt) === "select"
                              ? _c("v-select", {
                                  attrs: {
                                    items: opt.choices,
                                    "item-text": "label",
                                    "item-value": "value",
                                    label: opt.label,
                                    outlined: "",
                                    dense: "",
                                    "hide-details": ""
                                  },
                                  model: {
                                    value: _vm.optionValues[opt.key],
                                    callback: function callback($$v) {
                                      _vm.$set(_vm.optionValues, opt.key, $$v)
                                    },
                                    expression: "optionValues[opt.key]"
                                  }
                                })
                              : _vm.optType(opt) === "radio"
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "subtitle-2 mb-1"
                                      },
                                      [_vm._v(_vm._s(opt.label))]
                                    ),
                                    _c(
                                      "v-radio-group",
                                      {
                                        staticClass: "mt-0",
                                        attrs: {
                                          dense: "",
                                          "hide-details": "",
                                          "aria-label": opt.label
                                        },
                                        model: {
                                          value: _vm.optionValues[opt.key],
                                          callback: function callback($$v) {
                                            _vm.$set(
                                              _vm.optionValues,
                                              opt.key,
                                              $$v
                                            )
                                          },
                                          expression: "optionValues[opt.key]"
                                        }
                                      },
                                      _vm._l(opt.choices || [], function(c) {
                                        return _c("v-radio", {
                                          key: c.value,
                                          attrs: {
                                            label: c.label,
                                            value: c.value
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm.optType(opt) === "checkbox"
                              ? _c("v-checkbox", {
                                  staticClass: "mt-0",
                                  attrs: {
                                    label: opt.label,
                                    dense: "",
                                    "hide-details": ""
                                  },
                                  model: {
                                    value: _vm.optionValues[opt.key],
                                    callback: function callback($$v) {
                                      _vm.$set(_vm.optionValues, opt.key, $$v)
                                    },
                                    expression: "optionValues[opt.key]"
                                  }
                                })
                              : _vm.optType(opt) === "text"
                              ? _c("v-text-field", {
                                  attrs: {
                                    label: opt.label,
                                    outlined: "",
                                    dense: "",
                                    "hide-details": "auto",
                                    counter: opt.max || undefined,
                                    rules: _vm.textRules(opt)
                                  },
                                  model: {
                                    value: _vm.optionValues[opt.key],
                                    callback: function callback($$v) {
                                      _vm.$set(_vm.optionValues, opt.key, $$v)
                                    },
                                    expression: "optionValues[opt.key]"
                                  }
                                })
                              : _vm.optType(opt) === "password"
                              ? _c("v-text-field", {
                                  attrs: {
                                    label: opt.label,
                                    outlined: "",
                                    dense: "",
                                    "hide-details": "auto",
                                    type: _vm.revealOpt[opt.key]
                                      ? "text"
                                      : "password",
                                    counter: opt.max || undefined,
                                    rules: _vm.textRules(opt),
                                    autocomplete: "new-password"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "append",
                                        fn: function fn() {
                                          return [
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "kvm-pick__reveal",
                                                attrs: {
                                                  icon: "",
                                                  "x-small": "",
                                                  "aria-label":
                                                    (_vm.revealOpt[opt.key]
                                                      ? "Hide "
                                                      : "Show ") + opt.label,
                                                  "aria-pressed": _vm.revealOpt[
                                                    opt.key
                                                  ]
                                                    ? "true"
                                                    : "false"
                                                },
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.revealOpt,
                                                      opt.key,
                                                      !_vm.revealOpt[opt.key]
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      "aria-hidden": "true"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.revealOpt[opt.key]
                                                          ? "mdi-eye-off"
                                                          : "mdi-eye"
                                                      )
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: _vm.optionValues[opt.key],
                                    callback: function callback($$v) {
                                      _vm.$set(_vm.optionValues, opt.key, $$v)
                                    },
                                    expression: "optionValues[opt.key]"
                                  }
                                })
                              : _vm.optType(opt) === "password_generate"
                              ? _c(
                                  "div",
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: opt.label,
                                        outlined: "",
                                        dense: "",
                                        "hide-details": "auto",
                                        type: _vm.revealOpt[opt.key]
                                          ? "text"
                                          : "password",
                                        counter: opt.max || undefined,
                                        rules: _vm.textRules(opt),
                                        autocomplete: "new-password"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "append",
                                            fn: function fn() {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass:
                                                      "kvm-pick__reveal",
                                                    attrs: {
                                                      icon: "",
                                                      "x-small": "",
                                                      "aria-label":
                                                        (_vm.revealOpt[opt.key]
                                                          ? "Hide "
                                                          : "Show ") +
                                                        opt.label,
                                                      "aria-pressed": _vm
                                                        .revealOpt[opt.key]
                                                        ? "true"
                                                        : "false"
                                                    },
                                                    on: {
                                                      click: function click(
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.revealOpt,
                                                          opt.key,
                                                          !_vm.revealOpt[
                                                            opt.key
                                                          ]
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          "aria-hidden": "true"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.revealOpt[
                                                              opt.key
                                                            ]
                                                              ? "mdi-eye-off"
                                                              : "mdi-eye"
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: _vm.optionValues[opt.key],
                                        callback: function callback($$v) {
                                          _vm.$set(
                                            _vm.optionValues,
                                            opt.key,
                                            $$v
                                          )
                                        },
                                        expression: "optionValues[opt.key]"
                                      }
                                    }),
                                    _c(
                                      "gg-btn",
                                      {
                                        staticClass: "px-1 mt-1 kvm-pick__btn",
                                        attrs: {
                                          text: "",
                                          small: "",
                                          color: "primary",
                                          "aria-label":
                                            "Generate a strong password for " +
                                            opt.label
                                        },
                                        on: {
                                          click: function click($event) {
                                            return _vm.generatePassword(opt)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              left: "",
                                              small: "",
                                              "aria-hidden": "true"
                                            }
                                          },
                                          [_vm._v("mdi-auto-fix")]
                                        ),
                                        _vm._v("Generate ")
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "text-right mt-2"
                        },
                        [
                          _c(
                            "gg-btn",
                            {
                              staticClass: "mr-2 kvm-pick__btn",
                              attrs: {
                                text: ""
                              },
                              on: {
                                click: function click($event) {
                                  _vm.dialog = false
                                }
                              }
                            },
                            [_vm._v("Cancel")]
                          ),
                          _c(
                            "gg-btn",
                            {
                              staticClass: "kvm-pick__btn kvm-pick__confirm",
                              attrs: {
                                tile: "",
                                color: "primary",
                                disabled: !_vm.optionsValid
                              },
                              on: {
                                click: _vm.confirm
                              }
                            },
                            [_vm._v(_vm._s(_vm.confirmLabel))]
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }